"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            sites: null,
            mounted: {},
            payload: {},
            showEditor: false,
            showDialog: false,
            versionAssets: null,
            activeVersion: null,
            versions: [],
            loading: false,
            applying: false
        };
        GState.bind(this, [
            'user',
            'tenant'
        ]);
    },
    onMount: function () {
        this.fetchSites();
    },
    onBack: function (type) {
        this.state.showEditor = false;
        this.fetchSites();
        if (type == 'clear')
            this.state.mounted = {};
    },
    signContent: function (dataset) {
        return {
            ...dataset,
            date: new Date().toDateString(),
            author: getFullname(this.state.user),
            version: '2+',
            copyright: 'Multipple ' + (window.appversion || '')
        };
    },
    dialog: function (status) {
        this.state.showDialog = status;
    },
    fetchSites: async function (limit) {
        try {
            const {error, message, results} = await Request(`/site/list?limit=${ limit || 50 }`);
            if (error)
                throw new Error(message);
            this.state.sites = results;
        } catch (error) {
            console.log('Failed fetching Sites: ', error);
        }
    },
    openSite: async function (site) {
        const {siteId, title, description, draft, assets, version} = this.state.mounted = site;
        if (!assets && !draft) {
            this.state.showEditor = siteId;
            this.state.payload = { create: true };
            return;
        }
        this.state.versionAssets = assets;
        this.state.versions = !!assets ? Object.keys(assets) : [];
        this.state.loading = true;
        try {
            if (draft)
                this.state.payload = await DTF.read(draft.editable);
            else
                await this.mountVersion(version);
            this.state.loading = false;
            this.state.showEditor = siteId;
        } catch (error) {
            console.log('Open Site Error: ', error);
            this.state.loading = false;
        }
    },
    onUse: async function (id) {
        this.state.applying = id;
        try {
            const {error, message} = await Request(`/site/mount/${ id }`);
            if (error)
                throw new Error(message);
            this.state.applying = false;
            this.state.tenant.website = id;
            this.fetchSites();
        } catch (error) {
            console.log('Failed Mounting new Site: ', error);
            this.state.applying = false;
        }
    },
    deleteSite: async function (id, confirmed) {
        if (!confirmed) {
            this.dialog({
                status: 'warning',
                message: 'Do you really want to delete this site. This cannot be undo.',
                actions: {
                    yes: function () {
                        this.deleteSite(id, true);
                    }.bind(this)
                }
            });
            return;
        }
        try {
            const {error, message} = await Request(`/site/delete/${ id }`, 'DELETE');
            if (error)
                throw new Error(message);
            this.fetchSites();
        } catch (error) {
            console.log('Failed Deleting Site: ', error);
        }
    },
    mountVersion: async function (version) {
        if (!version || !this.state.versionAssets || isEmpty(this.state.versionAssets))
            throw new Error('No Asset Found');
        const assets = await DTF.read(this.state.versionAssets[version].editable);
        this.setState({
            activeVersion: version,
            payload: {
                ...assets,
                version,
                versions: this.state.versions
            }
        });
    },
    onSave: async function (data, asDraft, callback) {
        try {
            if (typeof asDraft == 'function') {
                callback = asDraft;
                asDraft = false;
            }
            const {type, Delta, Assets, HTMLContent} = data, editable = await DTF.write(this.signContent({
                    type,
                    Delta,
                    Assets
                }), 'modela', 'website'), poster = Assets.cover && Assets.cover[0] && Assets.cover[0].src || Assets.image && Assets.image[0] && Assets.image[0].src || Assets.global && Assets.global[0] && Assets.global[0].src;
            let pages;
            if (!asDraft && !HTMLContent)
                throw new Error('Undefined HTMLContent');
            if (HTMLContent) {
                async function HTMLtoCDN(content) {
                    const {error, message, links} = await DTF.toCDN(new Blob([content], { type: 'text/html' }), 'website');
                    if (error)
                        throw new Error('Failed Uploading HTMLContent: ', message);
                    return links[0];
                }
                pages = {};
                if (typeof HTMLContent == 'string')
                    pages['/'] = await HTMLtoCDN(HTMLContent);
                else
                    for (let path in HTMLContent)
                        try {
                            pages[path] = await HTMLtoCDN(HTMLContent[path]);
                            if (Delta.Pages && Delta.Pages[path] && Delta.Pages[path]._default)
                                pages._default = path;
                        } catch (error) {
                            console.log(`Failed saving ${ path } HTML Content to CDN`, error);
                        }
            }
            const {title, description} = this.state.mounted, payload = {
                    title,
                    description,
                    poster,
                    assets: {
                        asDraft,
                        editable,
                        pages
                    }
                };
            let _siteId;
            if (!this.state.mounted.siteId) {
                const {error, message, siteId} = await Request('/site/create', 'POST', {
                    ...payload,
                    type: this.state.contentType
                });
                if (error)
                    throw new Error(message);
                _siteId = siteId;
            } else {
                const {error, message, site} = await Request(`/site/update/${ this.state.mounted.siteId }`, 'PUT', payload);
                if (error)
                    throw new Error(message);
                _siteId = site.siteId;
            }
            this.state.payload = {
                ...this.state.payload,
                Delta,
                Assets
            };
            this.state.mounted.siteId = _siteId;
            typeof callback == 'function' && callback();
            this.onBack('clear');
        } catch (error) {
            console.log('Failed Saving Website: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Website/Manager.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_DTF = require("delta2file"),
    DTF = module_DTF.default || module_DTF,
    LoadingPage_template = require("../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    EmptyList_template = require("../../components/EmptyList.marko"),
    EmptyList_tag = marko_loadTag(EmptyList_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_loadNestedTag = require("marko/dist/runtime/helpers/load-nested-tag"),
    Row_col_nested_tag = marko_loadNestedTag("col", 1),
    marko_mergeNestedTagsHelper = require("marko/dist/runtime/helpers/merge-nested-tags"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    DialogModal_template = require("../../../components/DialogModal/index.marko"),
    DialogModal_tag = marko_loadTag(DialogModal_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    Extension_template = require("../../../components/Extension/index.marko"),
    Extension_tag = marko_loadTag(Extension_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "px-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("cf967c"),
    marko_node0 = marko_createElement("br", null, "32", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "33", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "card item"
      },
    marko_attrs2 = {
        "class": "card-content"
      },
    marko_attrs3 = {
        "class": "card-body"
      },
    marko_attrs4 = {
        "class": "overflow-hidden font-medium-3"
      },
    marko_attrs5 = {
        "class": "text-ellipsis-2 mt-4"
      },
    marko_attrs6 = {
        "class": "font-small-2 text-muted py-25"
      },
    marko_attrs7 = {
        "class": "btn btn-secondary btn-sm"
      },
    marko_attrs8 = {
        "class": "list-inline m-0"
      },
    marko_attrs9 = {
        tile: "Edit Details",
        "class": "px-50 cursor-pointer"
      },
    marko_attrs10 = {
        title: "Open Website",
        "class": "px-50 cursor-pointer"
      },
    marko_attrs11 = {
        title: "Delete",
        "class": "px-50 cursor-pointer"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (!state.showEditor) {
    Wrapper_Admin_tag({
        renderBody: function(out) {
          if (state.sites === null) {
            LoadingPage_tag({}, out, __component, "1");
          } else if (!state.sites.length) {
            EmptyList_tag({
                routeTo: "create_website"
              }, out, __component, "2");
          } else {
            out.be("div", marko_attrs0, "3", component);

            Row_tag(marko_mergeNestedTagsHelper({
                renderBody: function(out, $nestedTagRow$0) {
                  var $for$0 = 0;

                  marko_forOf(state.sites, function(site, index) {
                    var $keyScope$0 = "[" + (($for$0++) + "]");

                    Row_col_nested_tag({
                        ns: "col-lg-3 col-md-4 col-12",
                        qs: "col-4",
                        hs: "col-5",
                        renderBody: function(out) {
                          out.be("div", marko_attrs1, "5" + $keyScope$0, component);

                          out.be("div", marko_attrs2, "6" + $keyScope$0, component);

                          Image_tag({
                              alt: site.title,
                              src: site.poster,
                              class: "w-100",
                              style: "height:150px",
                              icon: "bx bx-world"
                            }, out, __component, "7" + $keyScope$0);

                          out.be("div", marko_attrs3, "8" + $keyScope$0, component);

                          out.e("div", marko_attrs4, "9" + $keyScope$0, component, 1)
                            .t(site.title, component);

                          out.e("p", marko_attrs5, "10" + $keyScope$0, component, 1)
                            .t(site.description, component);

                          out.be("span", marko_attrs6, "11" + $keyScope$0, component);

                          if (site.updated) {
                            Locale_tag({
                                text: "Updated"
                              }, out, __component, "12" + $keyScope$0);

                            out.t(" ");

                            out.t(formatDate(site.updated.at, "calendar"), component);
                          } else {
                            Locale_tag({
                                text: "Created"
                              }, out, __component, "13" + $keyScope$0);

                            out.t(" ");

                            out.t(formatDate(site.created.at, "calendar"), component);
                          }

                          out.ee();

                          out.e("br", null, "14" + $keyScope$0, component, 0);

                          out.e("br", null, "15" + $keyScope$0, component, 0);

                          Row_tag({
                              col: [
                                  {
                                      renderBody: function(out) {
                                        if (state.tenant.website == site.siteId) {
                                          Locale_tag({
                                              text: "CURRENT",
                                              class: "badge badge-primary white-text font-small-2"
                                            }, out, __component, "18" + $keyScope$0);
                                        } else if (!site.draft) {
                                          out.be("button", marko_attrs7, "19" + $keyScope$0, component, null, 0, {
                                              onclick: __component.d("click", "onUse", false, [
                                                  site.siteId
                                                ])
                                            });

                                          Locale_tag({
                                              text: "Use"
                                            }, out, __component, "20" + $keyScope$0);

                                          Preloader_tag({
                                              active: state.applying == site.siteId
                                            }, out, __component, "21" + $keyScope$0);

                                          out.ee();
                                        }
                                      }
                                    },
                                  {
                                      class: "col text-right",
                                      renderBody: function(out) {
                                        out.be("ul", marko_attrs8, "23" + $keyScope$0, component);

                                        out.be("li", marko_attrs9, "24" + $keyScope$0, component);

                                        route_link_tag({
                                            href: "/edit-website/" + site.siteId,
                                            renderBody: function(out) {
                                              Bx_tag({
                                                  type: "pencil",
                                                  class: "font-medium-5"
                                                }, out, __component, "26" + $keyScope$0);
                                            }
                                          }, out, __component, "25" + $keyScope$0);

                                        out.ee();

                                        out.be("li", marko_attrs10, "27" + $keyScope$0, component, null, 0, {
                                            onclick: __component.d("click", "openSite", false, [
                                                site
                                              ])
                                          });

                                        if ((state.mounted.siteId == site.siteId) && state.loading) {
                                          Preloader_tag({
                                              active: true,
                                              class: "font-medium-5"
                                            }, out, __component, "28" + $keyScope$0);
                                        } else {
                                          Bx_tag({
                                              type: "link-external",
                                              class: "font-medium-5"
                                            }, out, __component, "29" + $keyScope$0);
                                        }

                                        out.ee();

                                        if (state.tenant.website != site.siteId) {
                                          out.be("li", marko_attrs11, "30" + $keyScope$0, component, null, 0, {
                                              onclick: __component.d("click", "deleteSite", false, [
                                                  site.siteId,
                                                  false
                                                ])
                                            });

                                          Bx_tag({
                                              type: "trash",
                                              class: "font-medium-5"
                                            }, out, __component, "31" + $keyScope$0);

                                          out.ee();
                                        }

                                        out.ee();
                                      }
                                    }
                                ]
                            }, out, __component, "16" + $keyScope$0);

                          out.ee();

                          out.ee();

                          out.ee();
                        }
                      }, $nestedTagRow$0);
                  });
                }
              }), out, __component, "4");

            out.n(marko_node0, component);

            out.n(marko_node1, component);

            route_link_tag({
                href: "/create-website",
                class: "btn btn-primary btn-lg",
                renderBody: function(out) {
                  Locale_tag({
                      text: "Add a Website"
                    }, out, __component, "35");
                }
              }, out, __component, "34");

            out.ee();
          }

          if (state.showDialog) {
            const { message, actions, ...rest } = state.showDialog

            DialogModal_tag(marko_assign({
                message: message,
                actions: actions
              }, rest), out, __component, "36", [
              [
                "dismiss",
                "dialog",
                false,
                [
                    false
                  ]
              ]
            ]);
          }
        }
      }, out, __component, "0");
  } else {
    Wrapper_tag({
        renderBody: function(out) {
          Extension_tag({
              name: "ModelaEditor",
              payload: {
                  ...(state.payload),
                  type: 'page',
                  exportInnerHTML: true,
                  backArrow: true
                }
            }, out, __component, "38", [
            [
              "output",
              "onSave",
              false
            ],
            [
              "version-change",
              "mountVersion",
              false
            ],
            [
              "back",
              "onBack",
              false,
              [
                  "normal"
                ]
            ],
            [
              "quit",
              "onBack",
              false,
              [
                  "clear"
                ]
            ]
          ]);
        }
      }, out, __component, "37");
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
